// extracted by mini-css-extract-plugin
export default {"container":"style_container__2-7he","tag":"style_tag__dIsQc","btn":"style_btn__gBlQu","archive":"style_archive__KFLl3","reinvite":"style_reinvite__bubrT"};